export class Configuration {
  static readonly DefaultResultsPerPage = 10;
  static readonly ShortResultsPerPage = 5;
  static readonly LongResultsPerPage = 100;
}
